import { useSelector } from 'react-redux';

import { ProfilePicture } from '../../shared/interface/index.js';
import { Selectors } from '../../store/index.js';

const Avatar: FC = () => {
    const uid = useSelector(Selectors.uid);

    const notificationCount = 0;

    return (
        <div className="avatar">
            <ProfilePicture uid={uid} />
            {notificationCount > 0 ? (
                <span className="notification-count">{notificationCount < 10 ? notificationCount : '9+'}</span>
            ) : null}
        </div>
    );
};

export default Avatar;
